import { useEffect, useState } from 'react';
import { ENDPOINTS } from '../../../../General/Utils/Endpoints';
import { Models } from '../../../../General/Utils/ModelsGeneral';
import axios from 'axios';
import PersonasModal from '../../../../General/Components/Catalogos/Personas/PersonasModal';
import AlertDialog from '../../../../Lms/Components/Shared/AlertDialog';

const EMPTY = {
  idPersona: 0,
  numeroEmpleado: '',
};

export default function Modal({
  open,
  mode = 'new',
  data = null,
  onClose,
  onSubmit,
  inline = false,
}) {

  const [rowsPersonas, setPersonas] = useState([]);
  const [rowsEmpleados, setEmpleados] = useState([]);
  const [personasOpen, setPersonasOpen] = useState(false); // 👈 abrir/cerrar modal Personas
  const [savingPersona, setSavingPersona] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({
    idPersona: '',
    numeroEmpleado: '',
  });
  const [alertDialog, setAlertDialog] = useState({ open: false, title: '', message: '', variant: 'info' });

  // Guardar el idPersona original en modo edición
  const [originalIdPersona, setOriginalIdPersona] = useState(0);

  const validateField = (field, rawValue) => {
    const value = typeof rawValue === 'string' ? rawValue.trim() : rawValue;
    let error = '';

    switch (field) {
      case 'idPersona': {
        const num = Number(value) || 0;
        if (!num || num <= 0) error = 'Selecciona una persona.';
        break;
      }
      case 'numeroEmpleado':
        if (!value) error = 'Captura el número de empleado.';
        break;
      default:
        break;
    }

    setErrors((prev) => ({
      ...prev,
      [field]: error,
    }));

    return !error;
  };

  const validateAll = () => {
    const okPersona = validateField('idPersona', form.idPersona);
    const okNumero = validateField('numeroEmpleado', form.numeroEmpleado);
    return okPersona && okNumero;
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
    validateField(field, value);
  };

  useEffect(() => {
    if (mode === 'edit' && data) {
      const filled = {
        idPersona: data.idPersona ?? 0,
        numeroEmpleado: data.numeroEmpleado ?? '',
      };
      setForm(filled);
      setOriginalIdPersona(data.idPersona ?? 0);
      validateField('idPersona', filled.idPersona);
      validateField('numeroEmpleado', filled.numeroEmpleado);
    } else {
      setForm(EMPTY);
      setOriginalIdPersona(0);
      setErrors({ idPersona: '', numeroEmpleado: '' });
    }
  }, [mode, data]);

  const isSaveDisabled =
    !form.idPersona ||
    !form.numeroEmpleado?.trim() ||
    !!errors.idPersona ||
    !!errors.numeroEmpleado;

  const errorStyle = {
    color: '#b91c1c',
    fontSize: '.8rem',
    display: 'block',
    marginTop: '.25rem',
  };

  const loadPersonas = async () => {
    try {
      const [resPersonas, resEmpleados] = await Promise.all([
        axios.get(ENDPOINTS.personas),
        axios.get(ENDPOINTS.empleados),
      ]);
      setPersonas((resPersonas.data || []).map((x) => Models.personas(x)));
      setEmpleados((resEmpleados.data || []).map((x) => Models.empleado(x)));
    } catch (e) {
      console.error(e);
      setAlertDialog({ open: true, title: 'Error', message: 'Error al obtener las personas', variant: 'error' });
    }
  };
  useEffect(() => { if (open) loadPersonas(); }, [open]);

  // Filtrar personas que ya tienen empleado asignado (excepto la persona del empleado actual en modo edición)
  const personasDisponibles = rowsPersonas.filter((persona) => {
    // En modo edición, permitir la persona actual
    if (mode === 'edit' && persona.idPersona === originalIdPersona) {
      return true;
    }
    // Excluir personas que ya tienen un empleado
    const yaAsignada = rowsEmpleados.some((e) => e.idPersona === persona.idPersona);
    return !yaAsignada;
  });

  if (!open) return null;

  const handleSubmitNuevaPersona = async (personaForm) => {
    try {
      setSavingPersona(true);
      const res = await axios.post(ENDPOINTS.personas, personaForm);
      const created = res?.data || {};

      // Refrescar catálogo
      await loadPersonas();

      // Extraer el ID de forma robusta
      let newId = 0;
      if (typeof created === 'number') {
        newId = created;
      } else if (typeof created === 'object' && created !== null) {
        newId = created.idPersona ?? created.IdPersona ?? created.id ?? created.Id ?? 0;
      }

      if (newId && newId > 0) {
        // Usar setTimeout para asegurar que el select se haya actualizado con las nuevas opciones
        setTimeout(() => {
          setForm((f) => ({ ...f, idPersona: newId }));
          validateField('idPersona', newId);
        }, 100);
      }
      setPersonasOpen(false);
    } catch (e) {
      console.error(e);
      setAlertDialog({ open: true, title: 'Error', message: 'No se pudo crear la persona.', variant: 'error' });
    } finally {
      setSavingPersona(false);
    }
  };

  const Header = (
    <div
      className="roles-topbar"
      style={{
        marginBottom: '0.6rem',
        paddingRight: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: '0 0 auto',
      }}>
      <h3 className="roles-title" style={{ marginRight: 0 }}>
        {mode === 'new' ? 'Nuevo empleado' : 'Editar empleado'}
      </h3>
      <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
    </div>
  );

  const Body = (
    <div
      style={{
        paddingLeft: '15%',
        paddingRight: 16,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.8rem',
        overflowY: 'auto',
        flex: '1 1 auto',
        minHeight: 0,
      }}>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem', display: 'flex', alignItems: 'center', gap: 8 }}>
          Persona:
          {/* 👇 BOTÓN que abre el modal de Personas */}
          <button
            type="button"
            className="btn-action"
            onClick={() => setPersonasOpen(true)}
            title="Crear nueva persona"
            style={{ padding: '2px 8px', lineHeight: 1 }}
          >
            ＋ Persona
          </button>
        </label>
        <br /><br />
        <select
          className={`infoField${errors.idPersona ? ' infoField--error' : ''}`}
          value={form.idPersona}
          onChange={e => handleChange('idPersona', e.target.value ? Number(e.target.value) : 0)}
        >
          <option value={0}>— Selecciona persona —</option>
          {personasDisponibles.map((persona) => {
            const fullName = `${persona.nombre || ''} ${persona.apellidoPaterno || ''} ${persona.apellidoMaterno || ''}`.trim();
            return (
              <option key={persona.idPersona} value={persona.idPersona}>
                {fullName}
              </option>
            );
          })}
        </select>
        {errors.idPersona && <small style={errorStyle}>{errors.idPersona}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Número de empleado:</label>
        <br /><br />
        <input
          className={`infoField${errors.numeroEmpleado ? ' infoField--error' : ''}`}
          value={form.numeroEmpleado}
          onChange={(e) => handleChange('numeroEmpleado', e.target.value)}
          maxLength={20}
        />
        {errors.numeroEmpleado && <small style={errorStyle}>{errors.numeroEmpleado}</small>}
      </div>
    </div>
  );

  const Footer = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '.6rem',
        marginTop: '.8rem',
        paddingRight: 16,
        flex: '0 0 auto',
      }}
    >
      <button className="roles-btn" onClick={onClose}>Cancelar</button>
      <button
        className="btn-action"
        onClick={() => {
          if (!validateAll()) return;
          onSubmit(form, mode);
        }}
        disabled={isSaveDisabled}
        style={{
          opacity: isSaveDisabled ? 0.5 : 1,
          cursor: isSaveDisabled ? 'not-allowed' : 'pointer',
        }}
      >
        {mode === 'new' ? 'Guardar' : 'Actualizar'}
      </button>
    </div>
  );

  if (inline) {
    return (
      <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {Header}
        {Body}
        {Footer}

        <PersonasModal
          open={personasOpen}
          mode="new"
          onClose={() => setPersonasOpen(false)}
          onSubmit={handleSubmitNuevaPersona}
        />
        {savingPersona && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.1)' }} />
        )}
        {alertDialog.open && (
          <AlertDialog
            open={alertDialog.open}
            onClose={() => setAlertDialog(prev => ({ ...prev, open: false }))}
            title={alertDialog.title}
            message={alertDialog.message || ""}
            variant={alertDialog.variant || "info"}
          />
        )}
      </div>
    );
  }

  return (
    <div
      className="roles-confirm-overlay"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        zIndex: 1000,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div
        className="roles-confirm-card"
        style={{
          width: 'min(720px, 96vw)',
          maxHeight: '85vh',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,.25)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {Header}
        {Body}
        {Footer}
      </div>
      {alertDialog.open && (
        <AlertDialog
          open={alertDialog.open}
          onClose={() => setAlertDialog(prev => ({ ...prev, open: false }))}
          title={alertDialog.title}
          message={alertDialog.message || ""}
          variant={alertDialog.variant || "info"}
        />
      )}
    </div>
  );
}
